import React from 'react';
import { Tooltip } from '@mui/material';

import { useOptionalPermissionCenter } from '../contexts/PermissionCenterContext';

/**
 * Makes a tooltip work around a disabled MUI control and explains a known
 * permission denial. Operational disabled states remain tooltip-free.
 */
export const PermissionTooltip = ({
  permission,
  permissions,
  requireAll = false,
  title = 'No permission',
  children,
}) => {
  const center = useOptionalPermissionCenter();
  const required = permissions || (permission ? [permission] : []);
  const knownDenied =
    center &&
    !center.loading &&
    !center.error &&
    required.length > 0 &&
    (requireAll
      ? !required.every(center.hasPermission)
      : !required.some(center.hasPermission));

  return (
    <Tooltip title={knownDenied ? title : ''} disableHoverListener={!knownDenied}>
      <span style={{ display: 'inline-flex' }}>{children}</span>
    </Tooltip>
  );
};

export default PermissionTooltip;
